/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"BlogTreeRootComponentQuery",
	"CollabDraftQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"ContentUnifiedWithSpaceKeyQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageRestrictionsContextQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WebStorageCategories",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery",
	"bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_154",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksQuery",
	"preloadCreateSpaceQuery",
	"preloadEditButtonWithSpaceKeyQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadSpaceBlogCountQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"relay_BlogTreeRootComponentQuery",
	"relay_CollabDraftQuery",
	"relay_ContentBlogUnifiedQuery",
	"relay_ContentHeaderUnifiedQuery",
	"relay_ContentPrerequisitesQuery",
	"relay_ContentTypesHeaderQuery",
	"relay_ContentUnifiedQuery",
	"relay_ContentUnifiedWithSpaceKeyQuery",
	"relay_CoverPictureQuery",
	"relay_EditContentButtonQuery",
	"relay_EditorContentStateQuery",
	"relay_FooterCreateButtonsQuery",
	"relay_LivePagesByLineLastUpdatedQuery",
	"relay_NativeCollabQuery",
	"relay_NotFoundContainerQuery",
	"relay_NotificationsButtonQuery",
	"relay_PersonalizedTemplatesV2AllTemplatesQuery",
	"relay_RendererContentStateQuery",
	"relay_RestrictedPageWithCanViewQuery",
	"relay_SpaceOverviewIdQuery",
	"relay_SpaceQuery",
	"relay_SpaceRestrictionCheckQuery",
	"relay_TopNavigationQuery",
	"relay_WhiteboardUnifiedQuery",
	"relay_contentAppearanceQuery",
	"relay_onboardingStateGetOnboardingStateQuery",
	"relay_onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"relay_onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"relay_onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"relay_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"relay_onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"relay_onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"relay_onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"relay_preloadCreateSpaceQuery",
	"relay_preloadEditButtonWithSpaceKeyQuery",
	"relay_preloadEditorNodeDataProvidersDataQuery",
	"relay_preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"relay_useFabricEligibilityMigrationQuery",
	"relay_useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"relay_useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"relay_useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"relay_useRegisterAdminAnnouncementBannerQuery",
	"relay_useShareAndRestrictButtonDataQuery",
	"relay_useSpaceEnabledContentTypesQuery",
	"relay_useTitleContentPropertiesForEditorQuery",
	"relay_useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"relay_useTitleContentPropertiesForPublishedPageQuery",
	"relay_useUserByLicensedProductsQuery",
	"requireSuperBatchFrontendResourceRenderQuery",
	"rightPanel",
	"searchCombinedConfig",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAnalyticsByLineQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useConfluenceStandardToPremiumExperimentQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useFollowingFeedWithSortByStorageFeedContentQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePreloadCommentButtonQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useShortcutsSpaceNavigationQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "eedf9ec3fffbffff9ef5dffffd7f5311d1e80815669be2f7bef7f9",
	"prod-apne2": "cad79ed3ff7affff9ef5defffdffd75fdfee7e7ff69ae2f79ef7f9",
	"prod-apse": "eeff9edffffaffff9ef5dffffd7fd3fdfffdff77fe9be2f7bef7fb",
	"prod-apse2": "eef79ed7fffaffffdff5dffffdff53ffffef7e7ffe9be2f7bef7ff",
	"prod-apsouth": "eedf9ed3fffafffffef5dffffdffd314c5e8082146dae6f79ef7fd",
	"prod-cacentral": "ceff9edbfffbffffd6f5dffffdffd314c5680020469ae2f79ff7fd",
	"prod-east": "eff79edffffbffffdff5dfffffff53ffffffff7fff9bfef7bfffff",
	"prod-eucentral": "eff79fd79ffaffff9ff5dfffefff5bffefffff6ffe9beef7beffff",
	"prod-eucentral2": "eef79ec1fffaffff9455deffad7f4315d5e800346290e2f39ef7f9",
	"prod-euwest": "eff79fdffffbffffdff5dffffffff3ffffffffffff9beef7bfffff",
	"prod-euwest2": "eeff9edffffbffffdff5dffffdff5315d1e80815669aeef79ff7fd",
	"prod-west2": "eef79fd7fffbffffdef5dfffffff53fbfbffff5ff79be2f7bffffb",
	"stg-east": "dbfcbecbfdfbdde75ef5fff7fd7f01000068000000dae2ffdffbfd"
};

export const generatedAt: string | null = "2026-07-02T03:11:47.974Z";
